import { render, staticRenderFns } from "./LoginRelationFunction.vue?vue&type=template&id=d3899646"
import script from "./LoginRelationFunction.vue?vue&type=script&lang=js"
export * from "./LoginRelationFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports